import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { RetryOnError, verifyToken } from "../utils/VerifyToken";
import { checkForAuthorization } from "utils/index";

export const FetchDashboardAnalytics = ({ from, to }) => {
    return useQuery(
        ['dashboard-analytics', from, to],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/admin/dashboard-analytics`,
                params: { ...(from ? { from } : {}), ...(to ? { to } : {}) },
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        select: (data) => data?.data?.data ?? null,
        keepPreviousData: true,
        // ~18 collection scans per request: don't re-run on every revisit.
        staleTime: 3 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}
